import { render, staticRenderFns } from "./testimonial-card.vue?vue&type=template&id=2e961101&scoped=true&"
import script from "./testimonial-card.vue?vue&type=script&lang=js&"
export * from "./testimonial-card.vue?vue&type=script&lang=js&"
import style0 from "./testimonial-card.vue?vue&type=style&index=0&id=2e961101&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e961101",
  null
  
)

export default component.exports